import VoiceModal from "./voice-modal.component";

export default VoiceModal;
